import _ from 'lodash';
import template from './kvadrant.html';
import { kvadrant_I } from './kvadrant.js';
import { kvadrant_II } from './kvadrant.js';
import { kvadrant_III } from './kvadrant.js';
import { kvadrant_IV } from './kvadrant.js';

class KvadrantController {
    constructor($scope) {
        this.kvadranti = [
            _.cloneDeep(kvadrant_I).concat(_.cloneDeep(kvadrant_II)),
            _.cloneDeep(kvadrant_IV).concat(_.cloneDeep(kvadrant_III))
        ];

        this.$scope = $scope;
        this.kvadrant = this.kvadrant || 1;
        // debugger;
        this.stavke = this.stavke || [];
        this.pozicije = [];
        this.dragStarted = false;
    }

    $onInit() {
        this.pozicije = this.kvadranti[this.kvadrant - 1];
        this.$scope.$watch('vm.stavke', this.refreshPozicije(), true);
    }

    onClick(pozicija) {
        if (!this.dragStarted) {
            this.pozicijaClicked({ pozicija: pozicija });
        }
    }

    refreshStavke() {
        let that = this;
        return (newValue, oldValue) => {
            that.pozicije.map(i => (i.selected = false));
            that.stavke.map(stavka => {
                that.pozicije.map(item => {
                    let pozicija = _.find(stavka.pozicije, { broj: item.broj });
                    if (_.isUndefined(pozicija) === false) {
                        item.selected = pozicija.selected;
                    }
                });
            });
        };
    }

    onDropComplete(toPozicija, fromPozicija, $event) {
        this.dragStarted = false;
        $event.event.stopPropagation();
        this.onDrop({ from: fromPozicija, to: toPozicija });
    }

    onDragStarted($event) {
        this.dragStarted = true;
    }

    refreshPozicije() {
        let that = this;
        return (newValue, oldValue) => {
            that.pozicije.map(pozicija => {
                let stavka = _.find(this.stavke, { broj: pozicija.broj });
                pozicija.selected = _.isObject(stavka);
            });
        };
    }
}

KvadrantController.$inject = ['$scope'];

const KvadrantComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: KvadrantController,
    controllerAs: 'vm',
    bindings: {
        stavke: '<',
        kvadrant: '<',
        pozicijaClicked: '&',
        onDrop: '&'
    }
};

export { KvadrantComponent };
export { KvadrantController };



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/kvadrant.component.js